module.exports = __webpack_public_path__ + "img/6.cc14854a.jpg";